
































import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
    props: {
        voltage: { type: [Number, String], required: false, default: null },
        loading: { type: Boolean, default: false },
        warning: { type: Boolean, default: false },
        batteryType: { type: String, default: "Unknown" },
        imageSrc: { type: String, default: "batteri-ladeniveau-forside_hvid70" }
    },
    setup(props) {
        const toNumberOrNaN = (v: unknown): number => {
            if (v === null || v === undefined) return NaN;
            if (typeof v === "number") return v;
            if (typeof v === "string") {
                const s = v.trim();
                if (!s) return NaN;
                const n = Number(s);
                return Number.isFinite(n) ? n : NaN;
            }
            return NaN;
        };

        const numericVoltage = computed(() => toNumberOrNaN(props.voltage));
        const voltageText = computed(() => {
            const v = numericVoltage.value;
            // N/A if NaN, not finite, or negative (incl. -1)
            if (!Number.isFinite(v) || v < 0) return "N/A";
            return `${v.toFixed(1)}V`
        });

        const imgSrc = computed(() => require(`@/assets/icons/${props.imageSrc}.svg`));

        return { imgSrc, voltageText };
    }
});
